const data = {
  'title': 'Opera',
  'content': 'Opera is an innovative space planning project for architects that prepares space plans for landlords, tenants and developers. Users have access to an array of tools to manipulate floorplans in real time.',
  'github': '',
  'live': 'https://www.geblertooth.co.uk/opera',
  'technologies': [
    'AWS',
    'TypeScript',
    'React',
    'Tailwind',
    'Terraform',
    'Serverless'
  ],
}

export default data
